export default {
  home: {
    title: 'Accueil',
    aiBannerTxt: {
      title: 'Concrétiser l\'éducation à l\'IA',
      subtitle: 'Autonomisation numérique de l\'IA+ Éducation, intégration de concepts innovants',
      description: 'Focus sur les produits et services techniques personnalisés au laser, aidant les institutions et les entreprises à intégrer "AI+ Education"'
    },
    description: 'Bienvenue sur notre site web marketing en Vue.js',
    banner: {
      slide1: {
        title:
          'Kits STEAM | Kits d’Intelligence Artificielle | Kits de Découpe Laser',
        description:
          'Nous proposons des solutions éducatives STEAM innovantes ainsi que divers kits pour les familles, les éducateurs et les distributeurs, spécialement conçus pour les enfants de 3 à 16 ans.',
      },
      slide2: {
        title: 'Des kits professionnels conçus pour la créativité des enfants',
        description:
          'Cours, équipements et logiciels intégrés pour faciliter l’apprentissage par projets',
      },
      slide3: {
        title: 'Une éducation technologique tournée vers l’avenir',
        description:
          'Pratique manuelle et intégration interdisciplinaire pour développer la résolution de problèmes et la capacité de collaboration',
      },
    },
    factory: {
      banner: {
        alt: 'Bannière d’usine intelligente',
        title: 'Solutions d’usine intelligente',
        description:
          'Construction de lignes de production | Capteurs industriels | Contrôle PLC et acquisition de données',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Ressources pédagogiques',
      resources: [
        {
          title: 'Supports pédagogiques basés sur des projets',
          desc: 'Présentations PPT des cours, supports de cours, conception d’activités en classe et recommandations d’évaluation.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Exemples de scénarios et ressources',
          desc: 'Exemples et extraits de code pour le contrôle des convoyeurs, la détection des postes et l’interconnexion des équipements.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Devoirs d’approfondissement après le cours',
          desc: 'Tâches prolongées et suggestions d’applications interdisciplinaires pour encourager l’exploration et la création.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Présentation du produit',
        desc: 'La solution d’usine intelligente est centrée sur la construction de lignes de production et le contrôle par programmation, couvrant les capteurs industriels, l’identification des postes, le contrôle PLC/microcontrôleurs et l’acquisition de données, avec un accent sur la pratique et la formation systématique.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Cours complémentaires',
        desc: 'Cours basés sur des projets conçus autour de la construction de lignes de production, des capteurs industriels, du contrôle PLC et de l’acquisition de données, avec un accent sur la pratique et la formation systématique.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Module de convoyeur',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Capteur photoélectrique',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'Unité de contrôle PLC',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Module de bras robotique',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Module de reconnaissance de codes-barres',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Capteur de température et d’humidité',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Module de commande de moteur',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Module de détection de poste',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Module d’arrêt d’urgence de sécurité',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Passerelle d’acquisition de données',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Solutions éducatives STEAM de Zetok',
      learnMore: 'En savoir plus >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Kits Zetok',
          description:
            'À travers la pratique et l’apprentissage par projets, nous développons la pensée innovante et les compétences pratiques.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Découpeuse et graveuse laser Good Laser',
          description:
            'Les découpeuses laser offrent une toute nouvelle expérience d’apprentissage pratique à l’éducation STEAM',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Scénarios pédagogiques',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'Solutions éducatives STEM',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Solutions d’espace maker',
        },
      ],
    },
    aiBanner: {
      alt: 'Bannière IA',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Kits Zetok',
      title: 'Kits d’Intelligence Artificielle',
      description:
        'Les kits d’intelligence artificielle comprennent généralement de nombreux projets interactifs et pratiques qui éveillent l’intérêt et la curiosité des élèves pour la technologie.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Carrousel de kits',
      title: 'Développer la pensée innovante',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Kits Zetok et découpeuses laser Good Laser',
      tabs: {
        kits: 'Kits',
        courses: 'Cours',
        laser: 'Équipements laser',
        software: 'Logiciels',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Kit d’initiation à la découpe laser',
            description: '(Comprend des consommables en panneaux de bois)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Boîte magique de sciences',
            description: '(Comprend panneaux de bois + kit de microcircuits)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'Kit de programmation en intelligence artificielle',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Système d’exploration scientifique – Maternelle',
            description: '(6 cours)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'Système maker STEAM pour adolescents',
            description: '(3 cours)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Cours de découpe laser',
            description: '(3 cours)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'Système de cours d’intelligence artificielle',
            description: '(4 cours)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: 'Découpeuse et graveuse laser CO₂ de bureau 55W',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description:
              'Découpeuse et graveuse laser professionnelle de bureau',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description:
              'Découpeuse et graveuse laser à lumière bleue intelligente de bureau',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Machine de marquage laser haute précision',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Plateforme d’apprentissage Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Plateforme cloud Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: 'Produits',
    smartFarm: 'Ferme intelligente',
    smartHome: 'Maison intelligente',
    smartTraffic: 'Trafic intelligent',
    smartFactory: 'Usine intelligente',
    laserSteam: 'Kit STEAM de découpe laser',
    dreamScience: 'Kit Science des Rêves',
    course: 'Cours',
    device: 'Appareils',
    education: 'Solutions éducatives',
    stem: 'Solutions éducatives STEM',
    maker: 'Solutions d’espace maker',
    software: 'Logiciels',
    service: 'Services et support',
    afterSale: 'Téléchargement des tutoriels',
    about: 'À propos',
    aboutUs: 'À propos de nous',
    dealer: 'Devenir notre distributeur',
    cooperation: 'Utilisation des produits et coopération éducative',
    news: 'Actualités',
    coursesSeries: 'Quatre grandes séries de cours',
    viewMore: 'Voir plus',
    store: 'Magasin'
  },
  globalContactForm: {
    title: 'Contactez-nous',
    subtitle:
      'Pour toute question ou besoin, n’hésitez pas à nous contacter. Nous serons ravis de vous servir',
    fields: {
      name: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      message: 'Message',
    },
    placeholders: {
      name: 'Veuillez saisir votre nom',
      email: 'Veuillez saisir votre adresse e-mail',
      phone: 'Veuillez saisir votre numéro de téléphone',
      company: 'Veuillez saisir le nom de votre entreprise',
      message: 'Veuillez décrire votre besoin ou votre question',
    },
    validation: {
      name: 'Veuillez saisir votre nom',
      email: 'Veuillez saisir votre e-mail',
      emailFormat: 'Le format de l’e-mail est incorrect',
      phone: 'Veuillez saisir votre numéro de téléphone',
      message: 'Veuillez saisir le message',
    },
    submit: 'Envoyer',
    submitting: 'Envoi en cours…',
    visual: {
      title: 'Service professionnel',
      description:
        'Axé sur l’éducation à la créativité technologique pour les enfants de 3 à 16 ans, avec des espaces maker et le développement de produits et de cours associés.',
    },
    contact: {
      phone: 'Ligne de service',
      email: 'Adresse e-mail',
    },
  },
  thankYou: {
    metaTitle: 'Merci',
    title: 'Merci pour votre envoi !',
    description:
      'Nous avons bien reçu vos informations et vous contacterons dès que possible.',
    seoDescription:
      'Soumission reçue. Notre équipe vous contactera prochainement.',
    backHome: 'Retour à l’accueil',
    browseProducts: 'Parcourir les produits',
    contactSupport: 'Contacter le support',
    nextStepsTitle: 'Les prochaines étapes',
    nextSteps: [
      'Notre équipe examinera votre demande sous 1–2 jours ouvrables.',
      'Si nécessaire, nous vous contacterons pour des informations supplémentaires.',
      'Vous pouvez continuer à parcourir le site ou nous joindre par téléphone ou e-mail.',
    ],
    contactTitle: 'Besoin d’une aide immédiate ?',
    contactPhoneLabel: 'Hotline de service :',
    contactEmailLabel: 'E-mail :',
  },
  about: {
    banner: {
      alt: 'Bannière À propos',
      title:
        'Zetok se concentre sur l’éducation innovante et propose des kits et des cours de haute qualité',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Notre mission',
      desc: 'Notre mission est de renforcer l’éducation grâce aux technologies avancées de l’intelligence artificielle, d’inspirer l’innovation et de former les futurs leaders et innovateurs. Nous croyons que fournir des outils et des solutions éducatives de haute qualité peut aider les élèves et les enseignants à réaliser pleinement leur potentiel.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Notre vision',
      desc: 'La technologie au service de l’éducation, permettant à chaque élève d’accéder à des ressources STEM de haute qualité, de révéler son potentiel et de former les futurs innovateurs et leaders.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Nos produits',
      tabs: ['Kits', 'Cours', 'Équipements laser'],
      items: [
        {
          title: 'Kits',
          desc: 'Nous proposons une large gamme de kits STEM, incluant l’intelligence artificielle, la robotique, la programmation et les expériences scientifiques, soigneusement conçus, faciles à utiliser et adaptés aux élèves de différents âges.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Cours',
          desc: 'Nos cours sont conçus par des experts en éducation pour être combinés avec les kits et offrir une expérience d’apprentissage complète, des concepts de base aux applications avancées, adaptés à différents niveaux.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Équipements laser',
          desc: 'Nos équipements de découpe et de gravure laser sont spécialement conçus pour les environnements éducatifs : sûrs, précis et faciles à utiliser, ils offrent aux élèves la possibilité de transformer leurs idées en réalisations concrètes.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Rejoignez-nous en tant que distributeur Zetok',
        title: 'Rejoignez-nous en tant que distributeur Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title:
          'Développez de nouvelles opportunités éducatives et partagez les fruits de l’innovation !',
        desc: 'Zetok vous invite à explorer de nouvelles voies de l’éducation STEM en proposant des kits d’IA, des équipements laser, etc., afin d’inspirer la créativité des élèves. Rejoignez-nous pour construire ensemble l’avenir !',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Notre mission',
        items: [
          {
            title: 'Produits de pointe',
            desc: 'Accès à des outils éducatifs STEAM de haute qualité sur le marché.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Forts bénéfices',
            desc: 'Bénéficiez de remises compétitives et d’incitations à la vente.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Support marketing',
            desc: 'Nous fournissons des supports marketing et des formations commerciales pour vous aider à développer rapidement votre marché.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Coopération de marque',
            desc: 'Collaborez avec Zetok pour partager l’influence de la marque et les ressources du marché.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Bannière de coopération',
        title: 'Coopération produit',
        cta: 'Contacter maintenant',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Éveiller le potentiel des futurs scientifiques et ingénieurs',
        desc: 'Rejoignez notre programme de promotion de l’éducation STEM et bénéficiez d’offres spéciales et d’essais de produits conçus pour les éducateurs. Nous fournissons des outils STEM innovants pour la classe, ainsi que des remises exclusives, afin de vous aider à former la prochaine génération d’innovateurs et de résolveurs de problèmes.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title:
          'Agissez maintenant et ouvrez un nouveau chapitre de l’éducation STEM !',
        items: [
          {
            title: 'Essai gratuit des produits',
            desc: 'Vous permet de tester nos outils avant l’achat.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Remises exclusives',
            desc: 'Nous proposons des solutions STEM économiques pour vos classes ou vos établissements.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Ressources pédagogiques',
            desc: 'Nous fournissons de riches ressources pédagogiques et des plans de cours pour soutenir vos activités éducatives.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Contactez-nous',
        desc: 'Pour toute question ou besoin, n’hésitez pas à nous contacter. Nous serons ravis de vous servir',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'Bannière du centre d’actualités',
        title: 'Centre d’actualités',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'Centre d’actualités',
      tabs: [
        { key: 'company', label: 'Actualités de l’entreprise' },
        { key: 'industry', label: 'Actualités du secteur' },
        { key: 'expo', label: 'Actualités des expositions' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zhongze lance un nouveau kit d’IA pour la classe',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'Coopération pilote de projets STEM avec des écoles locales',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title:
              'La mise à jour du logiciel améliore l’expérience de gestion en classe',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Organisation d’ateliers de formation pour les enseignants',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'Le réseau de distributeurs s’étend à de nouvelles régions',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title:
              'La nouvelle série de cours se concentre sur des projets réels',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'Le bilan annuel met en avant les réussites en innovation',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title:
              'Le programme de bien-être communautaire apporte le STEM aux jeunes',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title:
              'Tendance mondiale : application de l’apprentissage par projets en STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'L’IA dans l’éducation : meilleures pratiques émergentes',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title:
              'Les nouvelles normes des programmes mettent davantage l’accent sur les compétences pratiques',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title:
              'Le matériel éducatif s’adapte mieux aux besoins de la classe',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title:
              'Les projets STEAM continuent de progresser dans différents districts',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title:
              'Les projets de développement durable entrent dans les salles de classe STEM',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title:
              'Les espaces maker influencent les modes d’apprentissage innovants',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zhongze participe au salon des technologies éducatives',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title:
              'Présentation de projets d’étudiants lors de l’exposition régionale',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title:
              'Les démonstrations interactives lors des événements maker attirent l’attention',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Atelier de programmation visuelle destiné aux enseignants',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title:
              'Présentation de nouveaux équipements aux partenaires éducatifs',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },

  finance: {
    contact: {
      success:
        'Soumission réussie, nous vous contacterons dans les plus brefs délais',
      error: 'Échec de la soumission, veuillez réessayer plus tard',
      networkError:
        'Erreur réseau, veuillez vérifier votre connexion et réessayer',
    },
  },
  footer: {
    subscribePlaceholder: 'Votre numéro de téléphone et votre adresse e-mail',
    subscribe: 'S’abonner',
    subscribeSuccess: 'Abonnement réussi',
    contact: {
      sales: 'Hotline commerciale : +86 18379276683',
      service: 'Hotline service : +86 400 968 0598',
      email: 'E-mail : sam@zz-steam.com',
      address:
        'Adresse : Immeuble Huashengda, Bâtiment A, Rue Bagua 4, district de Futian, Shenzhen',
    },
    icp: 'Politique de confidentialité · Accord utilisateur Tous droits réservés © Zhongze Education (Shenzhen) Co., Ltd.粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'Bannière de la solution éducative STEM',
        title: 'Le moteur de la créativité en éducation STEM',
        description:
          'Destiné au K12, nous nous concentrons sur l’éducation STEM créative afin de stimuler la curiosité, développer la logique et allumer la passion de la programmation.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Éducation à l’intelligence artificielle et à la programmation',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Facile à apprendre et à utiliser',
            description:
              'Programmation graphique, prise en main instantanée pour les débutants, création facile de projets IA personnalisés.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Fonctionnalités puissantes',
            description:
              'Matériel intelligent, interaction vocale, créativité illimitée.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Grande extensibilité',
            description:
              'Connexion de composants matériels, stimulation de l’imagination, créativité sans limites.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Programme riche',
            description:
              'Cours complets, des bases à la pratique, pour aider les élèves à construire un système de connaissances solide.',
          },
        ],
      },
      scenes: {
        title: 'Découvrez nos cours phares',
        items: [
          {
            tab: 'Éducation scolaire',
            title: 'Éducation scolaire en IA',
            desc: 'Utilisation de kits d’intelligence artificielle pour créer des assistants vocaux intelligents, stimuler l’intérêt par la pratique, développer la logique et les compétences de programmation, et découvrir le charme de l’IA.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Formation aux compétitions',
            title: 'Formation aux compétitions',
            desc: 'Les kits intelligents soutiennent les compétitions de robotique et l’innovation technologique. Les élèves conçoivent des œuvres intelligentes et développent leurs capacités de collaboration et d’innovation.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Apprentissage en famille',
            title: 'Apprentissage en famille',
            desc: 'Apprentissage parent-enfant de projets d’intelligence artificielle, développement des capacités manuelles, renforcement des relations et amélioration de la culture technologique.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title:
          'IA + Éducation : ouvrir une nouvelle ère de l’apprentissage intelligent',
        desc: 'Grâce aux technologies de l’intelligence artificielle, personnalisation des parcours d’apprentissage et enseignement de précision, permettant à chaque élève de naviguer librement dans l’océan du savoir.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'Kits de la série STEM',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Bannière de la solution Maker Space',
        title: 'Explorez notre Maker Space',
        description:
          'Dans le Maker Space, l’éducation et la technologie innovante se combinent pour offrir aux élèves une plateforme de pratique et d’exploration.',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Compétences complètes de maker',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Application des outils techniques',
            desc: 'Programmation graphique, prise en main facile, les débutants peuvent rapidement créer des projets d’intelligence artificielle.',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Ouverture et flexibilité',
            desc: 'Maker Space, exploration libre, un terrain de jeu exclusif pour libérer la créativité.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Pratique manuelle',
            desc: 'Pratique manuelle, fabrication, expérimentation, exploration, pour entamer le voyage de l’apprentissage.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Apprentissage collaboratif',
            desc: 'Encourager les élèves à coopérer en équipe, développer l’esprit d’équipe et les compétences en communication.',
          },
        ],
      },
      scenes: {
        title: 'Scénarios d’application du Maker Space',
        items: [
          {
            tab: 'Cours manuels scolaires',
            title: 'Cours manuels scolaires',
            desc: 'Un complément efficace aux cours de travaux manuels, d’arts plastiques et de design.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Clubs de recherche et de pratique',
            title: 'Clubs de recherche et de pratique',
            desc: 'Fournir une plateforme de pratique pour les clubs d’innovation des écoles.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Laboratoires éducatifs',
            title: 'Laboratoires éducatifs',
            desc: 'Adapté aux écoles, universités ou laboratoires, pour moderniser l’environnement d’apprentissage et fournir des machines de gravure laser professionnelles aux étudiants.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Outils pour la concrétisation de la créativité',
        desc: 'Grâce à la capacité de découpe de précision des machines de découpe laser et à l’interaction intelligente des robots programmables, les élèves peuvent transformer des idées abstraites en œuvres physiques concrètes.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Kits de la série Maker',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Bannière de la page logicielle',
      title: 'Centre logiciel Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Téléchargement de logiciels',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light maker App',
          buttonText: 'Télécharger la version mobile',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'Télécharger le client',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Application de la plateforme d’apprentissage Zhongze',
          buttonText: 'Télécharger la version mobile',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Plateforme d’apprentissage Zhongze Technology',
          buttonText: 'Télécharger le client',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Logiciel dédié aux équipements laser Light Maker',
          desc: 'Intègre la conception graphique et le contrôle des équipements afin de faire gagner un temps considérable aux utilisateurs, en offrant une solution intégrée de conception et de contrôle laser.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Système de conception puissant et facile à utiliser',
            desc: 'Logiciel de création puissant, compatible avec les formats JPG, DXF, AI, DST, PNG, BMP, TIF, SVG pour des conceptions de haute qualité. DWG, DXF, AI, DST, PNG, BMP, TIF, SVG, etc.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Professionnalisme',
            desc: 'Fonctions de dessin professionnelles répondant à tous les besoins de fabrication. Qu’il s’agisse de conceptions complexes ou de découpes simples, tout se fait sans effort.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Facilité d’utilisation',
            desc: 'Dispose d’une interface conviviale et prend en charge de nombreux équipements laser. Ergonomie, interface multifonctionnelle ainsi qu’une capacité de découpe et de gravure efficace.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Plateforme cloud Zetok',
          desc: 'La plateforme cloud est un outil innovant de gestion éducative, conçu pour offrir aux enseignants, aux élèves et aux établissements une solution tout-en-un. Grâce à notre plateforme cloud, vous pouvez facilement gérer la remise et la réception des devoirs, la surveillance des équipements, les réparations et la configuration des paramètres.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'Utilisation pratique',
            desc: 'Création en un clic : bibliothèque intégrée et paramètres prédéfinis, prise en charge de la création en un clic pour simplifier les opérations. Surveillance des équipements : surveillance en temps réel de l’état des machines pour assurer le bon déroulement des activités pédagogiques.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'Gestion unifiée',
            desc: 'Connexion en parallèle des équipements : prise en charge de la connexion des autres équipements du laboratoire maker, gestion en un clic pour améliorer l’efficacité.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'Surveillance en temps réel',
            desc: 'État des équipements : suivi en temps réel de l’état de fonctionnement, déclaration rapide en cas de panne. Maintenance : le système rappelle régulièrement l’entretien en fonction du temps et de la fréquence d’utilisation, prolonge la durée de vie des équipements et améliore la qualité de découpe.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title:
            'Présentation de l’application de la plateforme d’apprentissage Zhongze',
          desc: 'Plateforme mobile fournissant cours, exercices et évaluations aux apprenants. Texte provisoire, pouvant être remplacé ultérieurement.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'Intelligent et pratique, sans souci pour les débutants',
            desc: 'Bibliothèque riche et paramètres prédéfinis intégrés, prise en charge de la création en un clic pour une prise en main rapide. Guide détaillé pour les débutants sur mobile, facilitant la maîtrise des opérations. Le service cloud permet la surveillance en temps réel de l’état des équipements de la salle de classe afin d’assurer la sécurité et l’efficacité de l’enseignement.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'Création par IA',
            desc: 'La création en un clic et la génération d’images par IA simplifient le processus de conception et améliorent l’efficacité créative. Les utilisateurs n’ont qu’à saisir des instructions simples ou télécharger des images de référence, et l’IA génère automatiquement des matériaux de haute qualité prêts à être découpés.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'Une nouvelle expérience d’apprentissage efficace',
            desc: 'La plateforme d’apprentissage Zetok intègre l’apprentissage des cours, la conception graphique et le traitement par découpe laser dans une seule solution, simple et pratique. La page d’accueil adopte un design en cartes qui distingue clairement les modules d’apprentissage, de conception et de traitement laser, assurant une transition fluide et améliorant considérablement l’efficacité de l’apprentissage.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title:
            'Présentation du logiciel de la plateforme d’apprentissage Zhongze Technology',
          desc: 'Plateforme complète fournissant la gestion des cours, l’attribution des devoirs et l’analyse d’évaluation. Texte provisoire pouvant être remplacé par un contenu détaillé ultérieurement.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-1/514/403',
            title: 'Gestion et publication des cours',
            desc: 'Gestion centralisée du contenu et des ressources pédagogiques, prise en charge de plusieurs types de supports et de formats.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-2/514/403',
            title: 'Analyse des données de classe',
            desc: 'Visualisation des données d’apprentissage et des résultats d’évaluation pour soutenir la prise de décision pédagogique.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-3/514/403',
            title: 'Collaboration multi-terminaux',
            desc: 'Fonctionne en synergie avec l’application et les équipements pour relier la salle de classe à la pratique.',
          },
        ],
      },
    },
  },

  product: {
    farm: {
      banner: {
        alt: 'Bannière de la ferme intelligente',
        title: 'Kit pédagogique de ferme intelligente',
        btnText: 'Acheter maintenant',
        description:
          'Enseignement par projet | Programmation + Matériel + IA | Adapté aux écoles primaires et collèges',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Contenu des cours par projet',
        resourceTitle: 'Ressources pédagogiques',
        equipmentsTitle: 'Configuration du matériel',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Contenu de cours riche et varié',
          desc: '12 leçons progressives : de la détection de température à l’irrigation intelligente et au contrôle thermique, un parcours complet.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Intégration de connaissances interdisciplinaires',
          desc: 'Chaque projet implique la programmation, l’électronique et la mécanique, aidant les élèves à appliquer leurs connaissances de manière globale et à renforcer leur pensée interdisciplinaire.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Thème proche de la vie quotidienne',
          desc: 'Basé sur le thème de la ferme intelligente, proche du quotidien des élèves, facile à susciter l’intérêt et l’engagement.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'PPT et supports pédagogiques complets',
          desc: '16 leçons avec PPT et supports correspondants aux projets pédagogiques, fournissant aux enseignants de riches ressources et allégeant la préparation des cours.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Vidéos d’assemblage des cours par projet',
          desc: 'Les vidéos montrent visuellement le processus de montage, aidant les élèves à mieux comprendre et maîtriser les étapes, améliorant l’efficacité de l’apprentissage.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Supports pédagogiques auxiliaires',
          desc: 'Les supports supplémentaires tels que les manuels offrent un guidage détaillé pour faciliter la révision et l’auto-apprentissage après les cours.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'Ruban LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Module horloge DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Capteur de température et d’humidité DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Capteur de mouvement (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Module d’éclairage LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Module ventilateur',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interrupteur optoélectronique en fente',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Module bouton',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Carte de contrôle principale',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Carte d’extension',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    home: {
      banner: {
        alt: 'Kit pédagogique de maison intelligente',
        title: 'Kit pédagogique de maison intelligente',
        btnText: 'Acheter maintenant',
        description:
          'Initiation à la programmation et à l’IA | Enseignement par projet | Choix privilégié pour les cours de technologie au primaire et au collège',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Avantages du kit d’initiation à la maison intelligente',
      resources: [
        {
          title: 'Ressources abondantes',
          desc: 'Fournit des ressources pédagogiques complètes pour faciliter l’enseignement des enseignants et l’apprentissage des élèves.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Intégration interdisciplinaire',
          desc: 'Chaque projet implique la programmation, l’électronique et la mécanique, favorisant l’application globale des connaissances et la pensée interdisciplinaire.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Tâches d’extension après les cours',
          desc: 'Tâches d’extension et recommandations d’applications interdisciplinaires pour stimuler la recherche et la création.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Cours associés',
        desc: 'Comprend 12 projets de qualité couvrant de nombreux aspects de la maison intelligente, tels que sonnette électronique, éclairage à variation, garage à détection, contrôle d’accès par mot de passe, alerte de gaz, alarme anti-intrusion, éclairage décoratif, lampe d’ambiance musicale, détection de la lumière du jour, détection de la température ambiante et ventilateur à contrôle thermique.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Multiples scénarios d’application',
      scenes: [
        {
          title: 'Enseignement en classe',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Développement créatif indépendant',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Interaction parent-enfant à domicile',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Présentation d’activités',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Configuration du matériel',
      equipments: [
        {
          title: 'Ruban LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Module horloge DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Capteur de température et d’humidité DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Capteur de mouvement (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Module d’éclairage LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Module ventilateur',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interrupteur optoélectronique en fente',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Module bouton',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Carte de contrôle principale',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Carte d’extension',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    factory: {
      banner: {
        alt: 'Bannière de l’usine intelligente',
        title: 'Kit pédagogique d’usine intelligente',
        btnText: 'Acheter maintenant',
        description: ` · Couverture complète capteurs / contrôle / entraînement <br>
 · Simulation de ligne de production réelle<br>
 · Former les « ingénieurs du futur »`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Caractéristiques du produit',
      resources: [
        {
          title: 'Expérience clé de l’Industrie 4.0',
          desc: 'Les élèves pratiquent capteurs, contrôle, actionnement et gestion des données sur une ligne de production simulée.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Apprentissage par projet',
          desc: 'Comprend des tutoriels de programmation et 12 cours avec PPT pour faciliter l’apprentissage des utilisateurs.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulation de scénarios réels',
          desc: 'Bras robotisé intelligent, système de tri automatique et entrepôt intelligent pour simuler la gestion logistique et des stocks et démarrer le parcours pratique STEM.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Présentation du produit',
        desc: 'Le kit pédagogique d’usine intelligente est un ensemble d’enseignement par projet combinant programmation, électronique, mécanique, découpe laser et vulgarisation de l’intelligence artificielle, destiné aux élèves du primaire et du collège. Sur le thème « Fabrication intelligente · Créer l’avenir », il simule un environnement de production pour développer l’exploration scientifique, la conception d’ingénierie, le contrôle par programmation et la coopération innovante.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Cours associés',
        desc: '12 cours de qualité couvrant l’initiation à l’usine intelligente, la compréhension des processus de production, les applications des capteurs, les bases des entraînements mécaniques, la construction de systèmes de transport, le tri automatique, le contrôle collaboratif des postes de travail, les bras d’assemblage et le tri intelligent. Les projets mettent l’accent sur la pratique et l’entraînement systématique.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Configuration du matériel',
      equipments: [
        {
          title: 'Ruban LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Module horloge DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Capteur de température et d’humidité DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Capteur de mouvement (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Module d’éclairage LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Module ventilateur',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interrupteur optoélectronique en fente',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Module bouton',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Carte de contrôle principale',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Carte d’extension',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'Bannière du kit STEAM de découpe laser',
          title: 'Kit STEAM de découpe laser',
          btnText: 'Acheter maintenant',
          description:
            'Une solution éducative de fabrication intelligente pour développer la créativité et la collaboration en équipe',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        aiBanner: {
          title: 'Éducation IA, départ intelligent',
          desc: 'Associer l’éducation STEAM à des éléments d’IA pour une expérience d’apprentissage complète.',
        },
        resourcesTitle: 'Avantages du kit STEAM de découpe laser',
        resources: [
          {
            title: 'Théorie des intelligences multiples',
            desc: 'Basé sur la théorie des intelligences multiples, le programme développe la créativité, la pensée critique, la résolution de problèmes et la communication collaborative.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Apprentissage par projet',
            desc: 'Grâce à l’apprentissage par projet, les élèves apprennent par la pratique, améliorant leur efficacité et leur motivation.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'Éducation STEAM',
            desc: 'Le contenu intègre les sciences, la technologie, l’ingénierie, l’art et les mathématiques afin de développer la pensée interdisciplinaire des élèves.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Enseignement détaillé associé',
          tabs: [
            { key: 'cutter', label: 'Machine de découpe laser' },
            { key: 'lesson', label: 'Cours associés' },
            { key: 'material', label: 'Matériel pédagogique' },
            { key: 'software', label: 'Logiciel' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        equipmentsTitle: 'Configuration du matériel',
      },

      // Kit Dream Science
      dreamScience: {
        banner: {
          alt: 'Bannière du kit Dream Science',
          title: 'Boîte magique de sciences (Kit Dream Science)',
          description:
            'Concepts scientifiques | Pensée scientifique | Pratique exploratoire | Attitude et responsabilité',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Contenu du kit',
        resources: [
          {
            title: 'Matériel d’expériences scientifiques',
            desc: 'Utilisé pour réaliser différentes expériences et projets scientifiques.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Ressources pédagogiques',
            desc: 'Inclut des PPT pédagogiques et des supports pour soutenir un semestre complet d’enseignement, étroitement alignés sur les projets et les notions clés.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Vidéos et supports d’assemblage',
            desc: 'Supports pédagogiques auxiliaires aidant les élèves à mieux comprendre et maîtriser les étapes de manipulation.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Objectifs pédagogiques',
        objectives: [
          {
            title: 'Capacité d’investigation scientifique',
            desc: 'Poser des questions, élaborer des plans, collecter et analyser des données',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Compétences en pratique de l’ingénierie',
            desc: 'Construire et tester manuellement, améliorer les solutions par itération',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Intégration interdisciplinaire',
            desc: 'Combiner mathématiques, physique et art pour réaliser des projets',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Public cible',
          description:
            'Élèves du primaire et du collège : adapté à différents âges, contribue à renforcer la culture scientifique et les compétences pratiques. Enseignants : fournit des ressources pédagogiques et un accompagnement pour aider à mieux mener les activités d’enseignement.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Image de la section de présentation',
        },
      },
    },

    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'Bannière Voir tous les kits',
        title: 'Série de kits',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Avec les projets au cœur de l’apprentissage, les élèves développent leur capacité à mobiliser leurs connaissances pour résoudre des problèmes concrets.',
      moreText: 'En savoir plus',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Kit d’apprentissage Ferme intelligente',
          desc: 'Centré sur les projets pour stimuler la créativité et les compétences pratiques des élèves, et développer leur capacité à résoudre des problèmes réels.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Kit d’apprentissage Maison intelligente',
          desc: 'Associe programmation, électronique, structure mécanique, découpe laser et initiation à l’IA pour offrir une expérience d’apprentissage complète.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Kit d’apprentissage Transport intelligent',
          desc: 'Un kit pédagogique par projets intégrant la programmation, l’électronique, la mécanique, la découpe laser et l’initiation à l’intelligence artificielle.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Kit d’apprentissage Usine intelligente',
          desc: 'Couvre les bases de l’intelligence artificielle et des cas pratiques, en guidant progressivement les élèves pour construire un système de connaissances complet.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit STEAM de découpe laser',
        //   desc: 'Le kit de cours STEAM de découpe laser s’appuie sur la théorie des intelligences multiples, la pédagogie STEAM et l’apprentissage par projets.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit Science des Rêves',
        //   desc: 'Le kit Science des Rêves répond aux besoins des différentes étapes d’apprentissage et stimule l’intérêt et l’esprit d’exploration scientifique des élèves.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: 'Bannière Transport intelligent',
        title: 'Kit d’apprentissage Transport intelligent',
        btnText: 'Acheter maintenant',
        description: `12 cours par projets 
<br>· Double programmation visuelle / Python  <br>
· Simulation de scénarios réels<br>
· Prêt à enseigner dès l’ouverture`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Caractéristiques du produit',
      resources: [
        {
          title: 'Recherche scientifique et innovation',
          desc: 'Les élèves utilisent des modules électroniques et des structures mécaniques pour construire un système de transport intelligent.',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Fort potentiel éducatif',
          desc: 'Permet de concevoir des projets tels que feux de circulation intelligents, passages piétons, parkings, afin de comprendre les concepts du transport intelligent.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Ressources riches',
          desc: 'Ressources pédagogiques complètes comprenant les PPT et polycopiés de 12 cours, ainsi que des vidéos et supports d’assemblage pour les projets.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Présentation du produit',
        desc: 'Le kit Transport intelligent pour le primaire et le secondaire, sur le thème de la « mobilité intelligente » et de la « sécurité routière », combine commande électronique et capteurs pour guider les élèves dans la conception et la construction de systèmes de transport intelligents, en simulant des scénarios réels afin de développer leur culture scientifique et leur créativité.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Cours associés',
        desc: 'Comprend des cours par projets sur la perception et le contrôle du trafic, l’interconnexion des signaux, la planification d’itinéraires, adaptés à différents niveaux et durées de cours.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Configuration du matériel',
      equipments: [
        {
          title: 'Ruban lumineux RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Module d’horloge DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Capteur de température et d’humidité DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Capteur de mouvement infrarouge',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Module d’éclairage LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Module ventilateur',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interrupteur photoélectrique à fente',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Module bouton-poussoir',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Carte de contrôle',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Carte d’extension',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'Bannière de la page produits',
      title: 'Produits et solutions Zetok',
      description:
        'Intégration de kits, cours, équipements et logiciels pour soutenir l’apprentissage par projets',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'Bannière du module des cours',
        title: 'Quatre grands systèmes de cours',
        description:
          'Les cours couvrent plusieurs domaines tels que les sciences, la technologie, l’ingénierie, l’art et les mathématiques (STEAM), favorisant l’intégration et l’application interdisciplinaires.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Découvrez nos cours phares',
        nav: ['Âge 3-6 ans', 'Âge 6-12 ans', 'Âge 8-13 ans', 'Âge 9-15 ans'],
        entries: [
          {
            title: 'Système d’exploration scientifique · Enfants (6 cours)',
            desc: 'À partir de phénomènes courants de la vie quotidienne, l’utilisation de matériel scientifique permet d’explorer davantage pour comprendre les lois et principes du développement des choses.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'Système Maker STEAM pour adolescents (3 cours)',
            desc: 'Exprimer sa créativité, utiliser les équipements, pratiquer et transformer ses idées en réalisations concrètes.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Système de cours de découpe laser (3 cours)',
            desc: 'Utilisation de l’équipement pour découper différentes pièces structurelles, les assembler en structures tridimensionnelles et les embellir. Compétences en programmation : compréhension de la logique et des principes de la programmation conditionnelle.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Système de cours en intelligence artificielle (4 cours)',
            desc: 'Utiliser les outils pour concevoir et fabriquer des œuvres, puis les rendre intelligentes par la programmation afin de résoudre des problèmes de la vie quotidienne.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Avantages des cours',
        details: [
          {
            title: 'Forte dimension pratique',
            description:
              'Apprendre par la pratique, transformer la théorie en compétences',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Développement de la pensée créative',
            description:
              'Concevoir par la pratique, résoudre les problèmes de manière créative',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Apprentissage par projets',
            description:
              'Apprendre par des projets et maîtriser les connaissances dans la pratique',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Exploration des technologies de pointe',
            description:
              'Suivre les avancées technologiques et apprendre l’application des kits intelligents',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Enseignement structuré',
            description:
              'Progression du simple au complexe, de la théorie à la pratique',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Allier plaisir et défi',
            description:
              'Le plaisir suscite l’intérêt, le défi libère le potentiel et favorise la croissance par l’exploration.',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Série de cours en intelligence artificielle',
        items: [
          {
            name: 'Ferme intelligente',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Maison intelligente',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Transport intelligent',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Usine intelligente',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'Bannière des cours IA',
        text: 'Apprentissage par projets, intégration interdisciplinaire, développement des capacités pratiques, de coopération et de résolution de problèmes. Sécurité et personnalisation réunies, mise en valeur des réalisations pour renforcer le sentiment d’accomplissement et accompagner la croissance des élèves.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'Produits laser',
        title: 'Produits laser Good Laser',
        description:
          'Équipements et solutions de découpe/gravure laser sûrs et faciles à utiliser pour l’éducation',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Nos avantages',
      extraNote: {
        light640_640:
          'Excellentes performances de découpe et de gravure\nPlusieurs modèles, plusieurs puissances laser pour répondre à différents besoins d’application\nType de laser : CO2 continu  Puissance laser : 60W–130W',
      },
      center: {
        title: 'Centre de produits',
        laser_accessories: 'Accessoires laser',
        air_purifier_name: 'Purificateur d\'air',
        description:
          'Nous proposons des solutions complètes d’équipements laser adaptées aux différents niveaux d’enseignement. Zetok a lancé quatre solutions officielles d’équipements laser que les écoles peuvent choisir selon leurs besoins pédagogiques réels.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Laser haute qualité et haute précision',
                bgColor: '#4285F4',
                description:
                  'Tube laser CO₂ de haute qualité épaissi, longueur d’onde 10640 nm, puissance de 55W, capable de couper jusqu’à 20 mm (acrylique), vitesse de travail jusqu’à 600 mm/s et précision de répétabilité de 0,025 mm, pour des découpes et gravures rapides et précises.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Système intégré de triple filtration des gaz',
                bgColor: '#FFBC0C',
                description:
                  'Conception intégrée avec filtres, charbon actif et couche UV-ozone pour une filtration multiple des fumées. Plus propre et plus écologique, sans besoin d’acheter un caisson de filtration séparé ni d’occuper plus d’espace.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Protection de sécurité au plus haut niveau',
                bgColor: '#34A853',
                description:
                  'A réussi les tests de sécurité les plus stricts SGS, produit laser de classe I certifié FDA. Conception unique des indicateurs de sécurité et d’état de fonctionnement pour un contrôle visuel clair de l’état de la machine.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Système de découpe laser simple et puissant',
                bgColor: '#0F9D58',
                description:
                  '· Paramètres de traitement différents selon les matériaux : découpe, gravure profonde, gravure légère, balayage, etc. · Large bibliothèque de fichiers pour améliorer l’efficacité de conception. · Caméra avec prise de vue ciblée pour assister la conception graphique et transformer la créativité en réalité.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Zone de travail',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610 (1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Mise au point automatique + positionnement au point rouge',
                  bgColor: '#FFBC0C',
                  description:
                    'La mise au point automatique permet un réglage rapide et précis avant la découpe et la gravure. Avec le faisceau de positionnement au point rouge, la position de travail est visible en temps réel, ce qui permet d’économiser un temps précieux et d’obtenir de meilleurs résultats.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Conception à porte arrière ouverte',
                  bgColor: '#34A853',
                  description:
                    'La conception ouverte permet de traiter des matériaux de longueur illimitée. Les plaques de 600 mm × ∞ rendent le travail plus pratique et moins contraignant.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excellentes performances de découpe et de gravure',
                  bgColor: '#4285F4',
                  description:
                    'La machine est équipée d’une grande plateforme de découpe atteignant une précision et une efficacité de niveau industriel pour le bois et l’acrylique, permettant la production en série de produits de haute qualité.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Tube laser de haute qualité et composants de précision',
                  bgColor: '#FFBC0C',
                  description:
                    'Gamme de produits diversifiée permettant de choisir différents types de laser et vitesses de traitement selon les besoins, offrant des possibilités illimitées pour le bois, le verre et l’acrylique.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Tests stricts de qualité optique, garantie de performance',
                  bgColor: '#34A853',
                  description:
                    'Sélection de tubes laser CO₂ de premier niveau avec contrôle précis du trajet optique et plus de 5 tests de coupe et de gravure pour garantir une sortie lumineuse stable et homogène, même pour les détails complexes.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Fonctions de sécurité complètes et avancées',
                  bgColor: '#4285F4',
                  description: `1. Arrêt d’urgence
<br>2. Voyant d’alarme
<br>3. Interrupteur étanche
<br>4. Mise à la terre
<br>5. Détecteur thermique intégré avec alarme automatique
<br>6. Protection par capot
<br>7. Fenêtre de protection en verre trempé`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durable et d’excellente qualité',
                  bgColor: '#FFBC0C',
                  description: `1. Idéal pour les projets unitaires ou la production à grande échelle.
<br>2. Large choix de zones de travail : de 600 × 400 mm à 1600 × 1000 mm.
<br>3. Vitesse de gravure incomparable.
<br>4. Conçu par des experts du secteur.
<br>5. Choix idéal pour les applications personnalisées, éducatives et industrielles.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Optimisation de la production par surveillance intelligente',
                  bgColor: '#34A853',
                  description:
                    'Développé pour protéger les composants sensibles (axes, tête laser, optiques, lentilles) contre la poussière et la saleté, garantissant un fonctionnement fiable pendant de nombreuses années.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Mise au point automatique + positionnement au point rouge',
                  bgColor: '#4285F4',
                  description:
                    'La mise au point automatique permet un réglage rapide et précis avant la découpe et la gravure. Le faisceau de point rouge permet de visualiser la position en temps réel, améliorant l’efficacité et la qualité des résultats.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excellentes performances de découpe et de gravure',
                  bgColor: '#FFBC0C',
                  description:
                    'Équipée d’une grande plateforme de découpe, la machine atteint une précision et une efficacité de niveau industriel pour le bois et l’acrylique, idéale pour la production en série.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durable et d’excellente qualité',
                  bgColor: '#34A853',
                  description: `1. Parfaite pour les projets unitaires ou la production de masse.
<br>2. Large plage de zones de travail : de 600 × 400 mm à 1600 × 1000 mm.
<br>3. Vitesse de gravure incomparable.
<br>4. Conçue par des experts du secteur.
<br>5. Idéale pour les applications personnalisées, éducatives et industrielles.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Graveuse laser bleue portable',
                bgColor: '#4285F4',
                description:
                  'Design élégant, moderne et compact, idéal pour la maison, l’école ou l’atelier. Corps en métal avec couvercle en acrylique, parfaitement adapté à un usage sur bureau, avec une puissance de 20W pour de meilleures performances de découpe.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Traitement fermé pour une sécurité maximale',
                bgColor: '#FFBC0C',
                description:
                  'Machine entièrement fermée : l’ouverture du couvercle pendant le fonctionnement provoque l’arrêt automatique. En cas d’urgence, un simple bouton permet l’arrêt immédiat, idéale pour un usage familial et scolaire.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Traitement multi-matériaux',
                bgColor: '#34A853',
                description:
                  'Personnalisation de formes et styles variés, avec accessoires pour la gravure sur objets cylindriques comme les tasses. Prend en charge plus d’une centaine de matériaux.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Scénarios d’application variés',
                bgColor: '#4285F4',
                description:
                  'Adaptée à de nombreux secteurs : gravure de bijoux, objets personnalisés, identification de pièces, de la bijouterie aux petites plaques industrielles.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Innovation pour le secteur éducatif',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20 introduit une précision de niveau industriel dans l’éducation et devient un assistant polyvalent pour la formation scientifique et technologique.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Compact et moderne',
                bgColor: '#34A853',
                description:
                  'Design compact, faible encombrement, faible bruit, grande fenêtre de visualisation, répondant aux exigences de durabilité et de sécurité.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Marquage en quelques secondes',
                bgColor: '#0F9D58',
                description:
                  'Même avec les plus petites polices, le marquage est réalisé en quelques secondes. Associé au logiciel LightMaker, le flux de travail est grandement optimisé pour une productivité accrue.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Accessoires',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
· Lieux d’utilisation : adapté à tous les endroits produisant fumées, odeurs, poussières et gaz nocifs.
<br>· Domaines d’application : électronique, jouets, quincaillerie de précision, médical.
<br>· Conception : postes simple ou double configurables.
<br>· Système de filtration : plusieurs niveaux de filtration.
<br>· Réglage du débit d’air : ajustement continu selon la quantité de gaz.
<br>· Efficacité de purification : jusqu’à 99,97 %.
<br>· Rejet de l’air : l’air purifié peut être rejeté directement à l’intérieur.
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Type d’équipement : accessoire pour machines de découpe/gravure laser.
<br>· Fonction : permet la rotation des pièces.
<br>· Objets compatibles : cylindres, tubes, etc.
<br>· Extension de fonction : permet la gravure et la découpe d’objets cylindriques.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· Machine de formage haute efficacité pour un façonnage précis.
<br>· Commande CNC, facile à utiliser.
<br>· Plusieurs moules disponibles.
<br>· Système de serrage rapide, améliore l’efficacité.
<br>· Dispositifs de sécurité complets.
<br>· Convient à de nombreux matériaux.
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
    support: {
      afterSales: {
        banner: {
          alt: 'Bannière des téléchargements de tutoriels',
          title: 'Téléchargement des tutoriels',
          image: require('@/assets/after/banner.png'),
        },
        downloadText: 'Télécharger le tutoriel',
        items: [
          {
            id: 'mk-1',
            name: 'Ferme intelligente',
            image: 'https://picsum.photos/seed/as-farm1/588/391',
            link: '#',
          },
          {
            id: 'mk-2',
            name: 'Maison intelligente',
            image: 'https://picsum.photos/seed/as-home1/588/391',
            link: '#',
          },
          {
            id: 'mk-3',
            name: 'Transport intelligent',
            image: 'https://picsum.photos/seed/as-traffic1/588/391',
            link: '#',
          },
          {
            id: 'mk-4',
            name: 'Usine intelligente',
            image: 'https://picsum.photos/seed/as-factory1/588/391',
            link: '#',
          },
          {
            id: 'mk-5',
            name: 'Espace maker',
            image: 'https://picsum.photos/seed/as-makerspace1/588/391',
            link: '#',
          },
          {
            id: 'mk-6',
            name: 'Cours de robotique',
            image: 'https://picsum.photos/seed/as-robot1/588/391',
            link: '#',
          },
          {
            id: 'mk-7',
            name: 'Tutoriels IA',
            image: 'https://picsum.photos/seed/as-ai1/588/391',
            link: '#',
          },
          {
            id: 'mk-8',
            name: 'Tutoriels IoT',
            image: 'https://picsum.photos/seed/as-iot1/588/391',
            link: '#',
          },
        ],
      },
    },
  },
};
